import { AllowFeature } from 'app/model/feature/allow-feature.model';

export class AttachFileFeature extends AllowFeature {
  public label : AttachFileLabel;

  constructor(featureData: any = undefined) {
    const isRequired = featureData && featureData.required === 'true';
    const isDiaplayed = featureData && featureData.display === 'true';
    super(!!isRequired, !!isDiaplayed);
  }
}

export class AttachFileLabel {
  en: string;
  th: string;
  constructor(label: any = undefined) {
      this.en = label && label.en;
      this.th = label && label.th;
  }
}



// WEBPACK FOOTER //
// ./src/app/model/feature/attach-file-feature.model.ts